export default "__VITE_ASSET__BOeOX0pw__"